import { useEffect, useState } from 'react';
import { Alert, Autocomplete, Box, Button, TextField, Typography } from '@mui/material';
import { fetchClientesComercial, useComercialContext } from './ComercialContext';
import { isSuccess } from '../common/domain/RemoteData.model';

const ComercialBanner = () => {
    const { actingAsCliente, setActingAsCliente, clearActingAsCliente } = useComercialContext();
    const [clientes, setClientes] = useState([]);

    useEffect(() => {
        fetchClientesComercial().then(result => {
            if (isSuccess(result)) setClientes(result.value);
        });
    }, []);

    return (
        <Alert severity="warning" sx={{ borderRadius: 0, alignItems: 'center' }} icon={false}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
                <Typography variant="body2" fontWeight="bold">
                    Modo comercial
                </Typography>
                {actingAsCliente ? (
                    <>
                        <Typography variant="body2">
                            Actuando como: <strong>{actingAsCliente.nombreRazonSocial}</strong> ({actingAsCliente.numCliente})
                        </Typography>
                        <Button size="small" variant="outlined" color="warning" onClick={clearActingAsCliente}>
                            Cambiar cliente
                        </Button>
                    </>
                ) : (
                    <Autocomplete
                        options={clientes}
                        getOptionLabel={c => `${c.numCliente} — ${c.nombreRazonSocial}`}
                        onChange={(_, cliente) => { if (cliente) setActingAsCliente(cliente); }}
                        size="small"
                        sx={{ minWidth: 300, background: 'white', borderRadius: 1 }}
                        renderInput={(params) => (
                            <TextField {...params} placeholder="Buscar cliente..." />
                        )}
                    />
                )}
            </Box>
        </Alert>
    );
};

export default ComercialBanner;
